import { SHARON_RACK_COUNTS } from './sharonS6RackData';

export const SHARON_S6_MODEL = Object.freeze({
  project: Object.freeze({
    id: 'sharon-s6',
    name: 'Sharon S6',
    accountName: 'Edf Purview 2',
    accountEmail: 'edfpurviewservices2@gmail.com',
    address: '3 Broadcast Way, Gore Hill, Artarmon NSW 2064',
    phase: 'Stage 1 Phase 3 - West',
    gpuPlatform: 'GB300 / NVL72',
    gpuCount: 4752,
    computeRacks: 66,
    totalRacks: 111,
    telemetryEnabled: false,
    sourceBasis: 'Rack layout + P2P layout + Panduit design/elevations + v6 active BOM + Panduit materials list',
  }),

  building: Object.freeze({
    width: 94,
    depth: 72,
    floorToFloor: 18,
    activeHallWidth: 74,
    activeHallDepth: 40,
  }),

  levels: Object.freeze({
    level1: Object.freeze({
      id: 'level1',
      label: 'Level 1 West - Data Hall 102',
      shortLabel: 'L1 West / DH102',
      elevation: 0,
      rackRows: 8,
      racks: SHARON_RACK_COUNTS.level1.total,
      architecturalPositions: 57,
      emptyArchitecturalPositions: 3,
      rackCounts: SHARON_RACK_COUNTS.level1,
      rooms: Object.freeze([
        'Data Hall 102',
        'Mechanical Corridor 1C',
        'Mechanical Corridor 1D',
        'Lift Lobby / Corridor 1B',
        'Corridor 1A / 1C / 1D',
        'MDF / service risers',
      ]),
      note: '54 Sharon racks are populated; three Hall 102 architectural cabinet positions remain unpopulated in the supplied P2P layout.',
    }),

    level2: Object.freeze({
      id: 'level2',
      label: 'Level 2 West - Data Hall 202',
      shortLabel: 'L2 West / DH202',
      elevation: 18,
      rackRows: 8,
      racks: SHARON_RACK_COUNTS.level2.total,
      architecturalPositions: 57,
      rackCounts: SHARON_RACK_COUNTS.level2,
      rooms: Object.freeze([
        'Data Hall 202 - 786 m2',
        'Mechanical Corridor 2D - 220 m2',
        'Corridor 2C - 70 m2',
        'Secure Trap 2A / 2B',
        'Lift Lobby / Corridor 2B',
        'Risers / access areas',
      ]),
      neighbour: Object.freeze({
        name: 'Data Hall 201',
        area: '789 m2',
        status: 'Architectural context only - not populated as part of the Sharon 111-rack deployment in this twin',
      }),
    }),
  }),

  containment: Object.freeze({
    inHall: '600 mm white communications basket / primary containment',
    outOfHall: 'Black containment outside data halls',
    rowCores: '2 x 90 mm core holes at either end of each rack row for DH1-02 / DH2-02 interconnection',
    vertical: '1 x 600 mm vertical cable tray between Level 2 and Level 1; final location is indicative in source drawing',
    fireStopping: '100 x 100 proprietary intumescent fire penetration treatment at fire safety walls',
  }),
});

export const SHARON_LEVEL_OPTIONS = Object.freeze([
  Object.freeze({ id: 'level1', label: 'Level 1 West - DH102' }),
  Object.freeze({ id: 'level2', label: 'Level 2 West - DH202' }),
  Object.freeze({ id: 'stacked', label: 'Stacked floors' }),
]);
